import { Fragment, useEffect, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import seat from '../../assets/seat.png';
import { AiFillCheckCircle, AiOutlineUp } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { getSeatClass, setSeatClass } from '../../features/search/searchSlice';

const categories = [
  { name: 'ECONOMY' },
  { name: 'BUSINESS' },
  { name: 'FIRST' },
];

export default function ListBoxCategory() {
  const [selected, setSelected] = useState(useSelector(getSeatClass));

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSeatClass(selected));
  }, [dispatch, selected]);

  return (
    <div className="">
      <Listbox
        value={selected}
        onChange={(e) => {
          dispatch(setSeatClass(e.name));
          setSelected(e.name);
        }}
      >
        <div className="relative ">
          <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none sm:text-sm">
            <span className="flex gap-3 truncate items-center">
              <img src={seat} alt="seat" className="w-4 h-4" />{' '}
              {selected?.name || selected}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <AiOutlineUp
                className="h-2 w-2 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {categories.map((category, categoryIdx) => (
                <Listbox.Option
                  key={categoryIdx}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ${
                      active ? 'bg-thirdly text-white' : 'text-gray-900'
                    }`
                  }
                  value={category}
                >
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {category.name}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-white">
                          <AiFillCheckCircle
                            className="h-5 w-5"
                            aria-hidden="true"
                          />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
